export {
  ACTIONKEY_FOR_PREDEFINED_COMMENTS,
  MINIMUM_LENGTH_OF_COMMENT,
  TRANSITION_TIMEOUT,
} from '../constant';

export const SIGNATURE_TNC_DESCRIPTION =
  'Under the Electronic Signature in Global and National Commerce Act (E-sign), this agreement and all electronic executed documents related hereto are legally binding in the same manner as are hard copy documents executed by hand signature.';

export const EMPTY_TEXT = '';

export const SIGNATURE_ALERT_COUNT_USERNAME = 'SIGNATURE_ALERT_COUNT_USERNAME';
export const SIGNATURE_ALERT_COUNT_SIGNATURE =
  'SIGNATURE_ALERT_COUNT_SIGNATURE';
export const SIGNATURE_ALERT_COUNT_AGREE_BTN =
  'SIGNATURE_ALERT_COUNT_AGREE_BTN';
export const SIGNATURE_ALERT_COUNT_COMMENT = 'SIGNATURE_ALERT_COUNT_COMMENT';

export const SIGNATURE_TAB_PASSWORD = 'esign_password';
export const SIGNATURE_TAB_TYPE = 'esign_type';
export const SIGNATURE_TAB_DRAW = 'esign_draw';
export const SIGNATURE_TAB_UPLOAD = 'esign_upload';
